import initGalleries from '@resources/js/components/galleries'
import Modal from '@resources/js/ui/Modal.js'

initGalleries()


const hotelCardsElements = document.querySelectorAll('.js-hotel-card')

hotelCardsElements.forEach(card => {
    card.classList.add('collapsed')

    const cardModal = new Modal(card, {
        toggleClass: 'showed-more',
        trigger: card.querySelector('.js-more-btn'),
        lockScroll: false,
    })
})
